import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('selfCareTypeDocuments')
export class TypeDocument {
  @JsonProperty('filename', String, true)
  public filename = '';

  @JsonProperty('description', String, true)
  public description = '';

  @JsonProperty('typeDocument', String, true)
  public typeDocument = '';

  @JsonProperty('attachmentGroup', String, true)
  public attachmentGroup = '';

  @JsonProperty('category', String, true)
  public category = '';

  @JsonProperty('multiple', Boolean, true)
  public isMultiple = false;

  public get label(): string {
    return this.filename;
  }

  public get value(): TypeDocument {
    return this;
  }
}
